<template>
  <div class="container mescroll-touch">
    <div class="borderTop"></div>
    <div class="content">
      <div class="countBox">
        <span class="total">{{ total }}</span>
        <div class="registerAccount">
          <img src="@/assets/images/userIcon.png" alt="" />
          <span>注册账号</span>
        </div>
      </div>
      <div class="filterTime">
        <span>筛选时间：</span>
        <div class="inputBox" @click="showStartDate = true">
          <input type="text" v-model="startTime" readonly @click="showStart = true" placeholder="开始时间" />
        </div>
        <van-popup v-model="showStartDate" round position="bottom" :style="{ height: '40%' }">
          <van-datetime-picker
            v-model="startDate"
            type="year-month"
            title="开始时间"
            @confirm="startDateConfirm"
            @cancel="showStartDate = false"
          />
        </van-popup>
        <span style="margin: 0 8px; color: transparent; background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%); -webkit-background-clip: text; background-clip: text;">—</span>
        <div class="inputBox" @click="showEndDate = true">
          <input type="text" v-model="endTime" readonly @click="showEnd = true" placeholder="结束时间" />
        </div>
        <van-popup v-model="showEndDate" round position="bottom" :style="{ height: '40%' }">
          <van-datetime-picker
            v-model="endDate"
            type="year-month"
            title="结束时间"
            @confirm="endDateConfirm"
            @cancel="showEndDate = false"
          />
        </van-popup>
      </div>
      <div class="recordBox">
        <div class="record">
          <p class="recordTitle">邀请记录</p>
          <div class="listBox">
            <van-loading v-if="loading" class="loading" type="spinner" size="26px" text-size="13px" vertical>加载中...</van-loading>
            <div class="list" v-if="!loading && list.length > 0">
              <div class="listItem" v-for="(item, index) in list" :key="index">
                <span class="name">{{ item.UserName }}</span>
                <span class="hospital van-multi-ellipsis--l2">{{ item.HospitalTitle }}</span>
                <span class="department">{{ item.SubjectName }}</span>
                <span class="time" v-if="item.RegisterTime">{{ item.RegisterTime.split('T')[0] }}</span>
              </div>
            </div>
            <p class="noData" v-if="!loading && list.length == 0">暂无更多数据~</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: 'MyInvitation',
  data() {
    return {
      showStartDate: false,
      startDate: new Date(),
      startTime: '',
      showEndDate: false,
      endDate: new Date(),
      endTime: '',
      loading: true,
      total: '',
      list: []
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.startTime = new Date().getFullYear() + '-' + (new Date().getMonth() + 1);
    this.endTime = new Date().getFullYear() + '-' + (new Date().getMonth() + 1);
    this.getList();
  },
  methods: {
    getList() {
      this.$axios.post('/Api/Api/Web/Customer/GetInvite', {
        StartTime: this.startTime,
        EndTime: this.endTime
      }).then(res => {
        this.loading = false;
        this.total = res.Data.Total;
        this.list = res.Data.List;
      })
    },
    startDateConfirm(date) {
      this.startDate = date;
      this.startTime = new Date(date).getFullYear() + '-' + (new Date(date).getMonth() + 1);
      this.endDate = date;
      this.endTime = new Date(date).getFullYear() + '-' + (new Date(date).getMonth() + 1);
      this.showStartDate = false;
      this.getList();
    },
    endDateConfirm(date) {
      this.endDate = date;
      if(this.endDate > this.startDate) {
        this.endTime = new Date(date).getFullYear() + '-' + (new Date(date).getMonth() + 1);
        this.getList();
      } else {
        this.$toast('结束时间不能小于开始时间')
      }
      this.showEndDate = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  position: relative;
  -webkit-text-size-adjust: none;
  background-color: #F9F8F7;
  box-sizing: border-box;
  .borderTop {
    width: 100%;
    height: 10px;
    background-color: #EB1700;
  }
  .content {
    display: flex;
    flex-direction: column;
    height: calc(100% - 10px);
    padding: 15px 25px;
    box-sizing: border-box;
  }
  .countBox {
    padding: 15px;
    background-color: #FFFFFF;
    text-align: center;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    .total {
      font-size: 28px;
      font-weight: bold;
      line-height: 28px;
      color: transparent; /* 使文字本身不可见 */
      background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 80%, #8C3BBB 100%); /* 定义渐变颜色 */
      -webkit-background-clip: text; /* 针对WebKit浏览器 */
      background-clip: text; /* 使渐变仅应用于文字 */
    }
    .registerAccount {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #564C47;
      img {
        display: block;
        width: 15px;
        margin-right: 3px;
      }
    }
  }
  .filterTime {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    margin: 20px 0;
    font-size: 14px;
    color: #564C47;
    .inputBox {
      flex: 1;
      height: 26px;
      background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
      padding: 1px;
      box-sizing: border-box;
      border-radius: 4px;
      input {
        width: 100%;
        height: 100%;
        border: none;
        border-radius: 4px;
        text-align: center;
        padding: 0 4px;
        box-sizing: border-box;
      }
    }
  }
  .recordBox {
    flex: 1;
    border-radius: 8px;
    .record {
      display: flex;
      flex-direction: column;
      max-height: 100%;
      background-color: #FFFFFF;
      border-radius: 8px;
      box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
      overflow: hidden;
      .recordTitle {
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        color: #FFFFFF;
        background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 85%, #8C3BBB 100%);
        line-height: 30px;
      }
      .listBox {
        display: flex;
        flex: 1;
        flex-direction: column;
        overflow: hidden;
        background: #FFFFFF;
        .loading {
          margin: 20px 0;
        }
        .noData {
          margin: 20px 0;
          text-align: center;
          font-size: 12px;
          color: #969799;
        }
        .list {
          flex: 1;
          padding: 0 15px;
          box-sizing: border-box;
          overflow-y: scroll;
          .listItem {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            font-size: 12px;
            color: #564C47;
            padding: 10px 0;
            background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%); /* 渐变方向从顶部到底部，颜色从#ff7e5f到#feb47b */
            background-size: 100% 1px; /* 调整背景大小，高度设置为下边框的厚度 */
            background-position: 0 100%; /* 背景位置在底部 */
            background-repeat: no-repeat; /* 不重复背景 */
            // span {
            //   display: inline-block;
            // }
            .name {
              width: 42px;
              margin-right: 8px;
              word-wrap: break-word;
            }
            .hospital {
              flex: 1;
              width: 0;
              margin-right: 8px;
            }
            .department {
              width: 42px;
              margin-right: 8px;
            }
            .time {
              width: 65px;
            }
          }
          .listItem:last-of-type {
            margin-bottom: 15px;
          }
        }
      }
    }
  }
}
</style>